import * as React from "react";
import { forwardRef } from "react";
const Svg16Px = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.3332 8L12.3932 8.94L8.6665 5.22V13.3333H7.33317V5.22L3.61317 8.94667L2.6665 8L7.99984 2.66667L13.3332 8Z", fill: "currentColor" }));
const ForwardRef = forwardRef(Svg16Px);
export default ForwardRef;
